export default __webpack_public_path__ + "static/media/settings-white.813af6d9.svg";